import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-logout on 401 (expired or invalid token)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => {
    // FastAPI-Users login uses OAuth2 form data (username + password)
    const formData = new URLSearchParams();
    formData.append('username', data.email);
    formData.append('password', data.password);
    return api.post('/auth/jwt/login', formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  },
  getCurrentUser: () => api.get('/auth/me'),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => api.post('/auth/reset-password', { token, password }),
};

export const bookingAPI = {
  create: (data) => api.post('/bookings', data),
  getAll: () => api.get('/bookings'),
  getOne: (id) => api.get(`/bookings/${id}`),
  update: (id, data) => api.patch(`/bookings/${id}`, data),
};

export const membershipAPI = {
  create: (data) => api.post('/memberships', data),
  getAll: () => api.get('/memberships'),
  getOne: (id) => api.get(`/memberships/${id}`),
};

export const partnershipAPI = {
  create: (data) => api.post('/partnerships', data),
  getAll: () => api.get('/partnerships'),
};

export const paymentAPI = {
  initialize: (data) => api.post('/payments/initialize', data),
  verify: (reference) => api.get(`/payments/verify/${reference}`),
};

export const adminAPI = {
  getStats: () => api.get('/admin/stats'),
};

export const configAPI = {
  getConfig: () => api.get('/config'),
};

// Reminders API
export const remindersAPI = {
  getPending: () => api.get('/reminders/pending'),
  getHistory: (limit = 50) => api.get(`/reminders/history?limit=${limit}`),
  sendReminder: (data) => api.post('/reminders/send', data),
  sendBulkReminders: (data) => api.post('/reminders/send-bulk', data),
};

// WhatsApp API
export const whatsappAPI = {
  getPending: () => api.get('/whatsapp/pending'),
  generateLink: (data) => api.post('/whatsapp/generate-link', data),
};

export default api;
